/**
 * Takes current filter and a new brand, removes or ads the brand depending on if it already exists
 * @param {string[]} currentBrandFilter
 * @param {string} brand
 * @returns {string[]}
 */
const addOrRemoveBrand = (currentBrandFilter, brand) => {
    return currentBrandFilter.includes(brand)
        ? currentBrandFilter.filter(b => {
              return b !== brand;
          })
        : [...currentBrandFilter, brand];
};

/**
 * Converts array to ; separated string, returns undefined if empty
 * @param {string[]} brands
 * @returns {string}
 */
const createBrandFilterString = brands =>
    brands && brands.length > 0 ? brands.join(';') : undefined;

export { addOrRemoveBrand, createBrandFilterString };



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/containers/search-results-page-logic.js